import { forwardRef } from 'react';
import { SvgConsumer } from '@components/icons/svgConsumer';
import { shortDate, shortDay } from '@utils/i18n';
import { cn } from '@utils/cn';
import { jobDayStatusStyle } from '../constants';
import { JobDayTabProps } from './types';

export const JobDayTab = forwardRef<HTMLButtonElement, JobDayTabProps>(
  ({ data, active, onClick }, ref) => (
    <button
      ref={ref}
      type="button"
      onClick={onClick}
      aria-pressed={active}
      className={cn(
        'flex h-7 shrink-0 items-center gap-1 whitespace-nowrap rounded border px-2.5 text-xs transition-shadow hover:shadow-md',
        jobDayStatusStyle[data.status],
        active && 'font-bold ring-2 ring-primary-500 ring-offset-1',
      )}>
      {data.status === 'completed' && (
        <SvgConsumer id="completedSolid" className="shrink-0 text-primary-500" />
      )}
      {[shortDay(data.day), shortDate(data.day)].join(', ')}
    </button>
  ),
);

// eslint-disable-next-line immutable/no-mutation
JobDayTab.displayName = 'JobDayTab';
